import React__default from 'react';
import { CommonStyles } from './BaseProps.es.js';
import { styled } from '@teko/styled';

const StyledDiv = styled.div `
  ${CommonStyles};
`;
const Shape = (props) => {
    return React__default.createElement(StyledDiv, Object.assign({}, props));
};

export { Shape };
